import isEmpty from 'utils/isEmpty';

/**
 * 필수 항목 입력 유효성 확인
 * @param {Object} data 요청 데이터
 * @param {string[]} [ignores] 선택 항목 키 목록
 * @return {boolean} 필수 항목 입력 유효성 여부
 */
function isValidRequired(data, ignores = []) {
  return Object.entries(data)
    .filter(([key]) => !ignores.includes(key))
    .every(([, value]) => !isEmpty(value));
}

export { isValidRequired };
